import { DocumentCard, Faq } from 'sections/Resources/FreightTemplates/Sli/types';

export const documentsCardData: DocumentCard[] = [
  {
    id: 1,
    iconName: 'icon-files.svg',
    heading: 'Dangerous Goods Declaration',
    url: '/resources/freight-templates/dangerous-goods-declaration',
    fileName: 'dangerous_goods_declaration',
  },
  {
    id: 2,
    iconName: 'icon-files.svg',
    heading: 'Proforma Invoice',
    url: '/resources/freight-templates/proforma-invoice',
    fileName: 'proforma_invoice',
  },
  {
    id: 3,
    iconName: 'icon-files.svg',
    heading: 'Commercial Invoice',
    url: '/resources/freight-templates/commercial-invoice',
    fileName: 'commercial_invoice',
  },
];

export const faq: Faq[] = [
  {
    id: "1",
    question: "Is an SLI mandatory for every shipment?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          It’s best practice. While you can coordinate via email, an SLI serves as a formal instruction and Power of Attorney. Most reputable forwarders won't move cargo without one to protect themselves.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "Who is responsible for filling it out?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          The Shipper (Exporter). The forwarder can guide them, but the shipper must verify the data and sign off on the instructions.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "Can I just send an email instead?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          You can, but emails get buried. An SLI is a standardized form that operations teams are trained to read. Using an SLI drastically reduces the chance of "human error" where a frantic email about insurance gets missed."
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "Does the SLI replace the Commercial Invoice?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          No. The SLI is an instruction to the forwarder; the Invoice is a declaration of value for customs. You need both."
        </p>
      `
    ),
  },
];